import { useQuery } from "@tanstack/react-query";

import type { ListSignatureRequestTemplatesResponseJSON } from "@performyard/service-contracts";

import {
	ListSignatureRequestTemplatesParams,
	type SignatureRequestTemplateDetailJSON,
	getSignatureRequestTemplateDetail,
	getSignatureRequestTemplates,
} from "../../services/defs/signature-request-templates";
import type { PYUseQueryOptions } from "../StandardQueryArguments";

export const signatureRequestTemplatesKeys = {
	all: ["SignatureRequestTemplates"] as const,
	list: (params?: ListSignatureRequestTemplatesParams) =>
		[...signatureRequestTemplatesKeys.all, "list", params] as const,
	detail: (templateId: string) => [...signatureRequestTemplatesKeys.all, "detail", templateId] as const,
};

export const useSignatureRequestTemplates = (
	params: ListSignatureRequestTemplatesParams = {},
	options?: PYUseQueryOptions<ListSignatureRequestTemplatesResponseJSON>
) => {
	return useQuery({
		queryKey: signatureRequestTemplatesKeys.list(params),
		queryFn: () => getSignatureRequestTemplates(params),
		meta: {
			errorMessage: "There was an error getting the signature request templates.",
		},
		...options,
	});
};

export const useSignatureRequestTemplateDetail = (
	templateId: string,
	options?: PYUseQueryOptions<SignatureRequestTemplateDetailJSON>
) => {
	return useQuery({
		queryKey: signatureRequestTemplatesKeys.detail(templateId),
		queryFn: () => getSignatureRequestTemplateDetail(templateId),
		enabled: !!templateId,
		meta: {
			errorMessage: "There was an error getting the signature request template.",
		},
		...options,
	});
};
